export type MailTextElement = {
    language: 'DE' | 'EN';
    defaultText: string;
    customText: string;
};

export const getMailTextElementByLanguage = (
    elements: MailTextElement[],
    language: 'DE' | 'EN'
) => {
    return elements.find((element) => element.language === language) || null;
};

export type MailTextVariable = {
    name: string;
    texts: MailTextElement[];
};

export type MailTextGroup = {
    name: string;
    variables: MailTextVariable[];
};

export type MailText = {
    liftOperatorId: string;
    groups: MailTextGroup[];
};
